export const videoPlatformsKeys = Object.freeze({
  zoom: 'zoom_id',
  webex: 'webex_link',
  teams: 'teams_email',
  google_meet: 'google_meet_link'
});
